export const BOOKING_DRAFT_KEY = "arctic-hire:booking-draft:v1"
export const BOOKING_SESSION_CLEARED_EVENT = "arctic-hire:booking-session-cleared"
export const BOOKING_DRAFT_TTL_MS = 24 * 60 * 60 * 1000

export function markPaymentSubmitted(token: string): void {
    try { window.sessionStorage.setItem(`arctic-hire:payment-submitted:${token}`, 'true') } catch { /* Storage may be unavailable. */ }
}

export function wasPaymentSubmitted(token: string): boolean {
    try { return window.sessionStorage.getItem(`arctic-hire:payment-submitted:${token}`) === 'true' } catch { return false }
}

export function clearCheckoutSessionStorage(): void {
    if (typeof window === "undefined") return
    const keys: string[] = []
    for (let index = 0;index < window.sessionStorage.length;index += 1) {
        const key = window.sessionStorage.key(index)
        if (key === "arctic-hire:pending-confirmation-token" || key?.startsWith("arctic-hire:checkout:") || key?.startsWith("arctic-hire:payment-submitted:")) {
            keys.push(key)
        }
    }
    keys.forEach((key) => window.sessionStorage.removeItem(key))
}

export function clearBookingSessionStorage(): void {
    if (typeof window === "undefined") return
    window.sessionStorage.removeItem(BOOKING_DRAFT_KEY)
    clearCheckoutSessionStorage()
    window.dispatchEvent(new Event(BOOKING_SESSION_CLEARED_EVENT))
}
